import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { TpaService } from '../features/tpa/services/tpa.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TpaDetailsGuard implements CanActivate {
  constructor(
    private tpaService: TpaService,
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.data['requiresSearchResults']) {
      const hasSearchResults = this.tpaService.hasSearchResults();

      if (!hasSearchResults) {
        const accountId = this.authService.getCurrentAccountId();
        this.router.navigate(['/' + accountId]).then();
        return false;
      }
    }

    return true;
  }
}
